export const categoryTypes: any = {
    LIVRES_TYPE: 'livres',
    VIDEOS_TYPE: 'videos',
    JEUX_TYPE: 'jeux',
    GOODIES_TYPE: 'goodies',
    MUSIQUE_TYPE: 'musique',
} as const;
